function turn_on_enquete_calendar(cal_prms){
    $(function () {
        // 非選択日
        var noSelectDays = [];
        if(cal_prms.no_select_days){
            noSelectDays = cal_prms.no_select_days;
        };

        // 日付フォーマット
        var dateFormat = "yy/mm/dd";
        dp_params = {
            language: "ja",
            dateFormat: dateFormat,
            // 非選択日の指定
            beforeShowDay: function (date) {
                var current = $.datepicker.formatDate(dateFormat, date);
                return [noSelectDays.indexOf(current) == -1, "", ""];
            },
        }
        // 開始日の設定
        if(!(cal_prms.min_date === undefined || cal_prms.min_date === null)){
            dp_params.minDate = cal_prms.min_date;
        }
        // 終了日の設定
        if(!(cal_prms.max_date === undefined || cal_prms.max_date === null)){
            dp_params.maxDate = cal_prms.max_date;
        }

        $(cal_prms.css_target).datepicker(dp_params);
    });
}

window.turn_on_enquete_calendar = turn_on_enquete_calendar;
